/**
 * System Status Component
 * Shows active tools, agents, skills, and MCP servers
 */

import { useState } from 'react';
import { getAnthropicTools } from '../lib/mcp-tools';
import { AGENT_TYPES } from '../lib/agent-system';
import { SKILLS } from '../lib/skills';

export function SystemStatus() {
  const [expanded, setExpanded] = useState(false);

  const tools = getAnthropicTools();
  const agents = Object.values(AGENT_TYPES);
  const skills = Object.keys(SKILLS);

  const mcpServers = [
    { name: 'filesystem', tools: 5, status: 'active' },
    { name: 'memory', tools: 6, status: 'active' },
    { name: 'web', tools: 2, status: 'active' },
    { name: 'computer-use', tools: 10, status: 'active' }
  ];

  if (!expanded) {
    return (
      <div className="system-status compact" onClick={() => setExpanded(true)}>
        <span className="status-icon">✅</span>
        <span className="status-text">
          System Ready: {tools.length} Tools • {agents.length} Agents • {skills.length} Skills • {mcpServers.length} MCP Servers
        </span>
        <span className="expand-hint">▼ Click to expand</span>
      </div>
    );
  }

  return (
    <div className="system-status expanded">
      <div className="status-header" onClick={() => setExpanded(false)}>
        <span className="status-icon">✅</span>
        <span className="status-text">System Status</span>
        <span className="collapse-hint">▲ Click to collapse</span>
      </div>

      <div className="status-grid">
        {/* Tools */}
        <div className="status-section">
          <h4>🛠️ Tools ({tools.length})</h4>
          <div className="status-items">
            {tools.slice(0, 10).map((tool, idx) => (
              <div key={idx} className="status-item">
                <span className="item-status">✓</span>
                <span className="item-name">{tool.name.replace('mcp__filesystem__', '').replace('_', ' ')}</span>
              </div>
            ))}
            {tools.length > 10 && (
              <div className="status-item">
                <span className="item-count">+{tools.length - 10} more</span>
              </div>
            )}
          </div>
        </div>

        {/* Agents */}
        <div className="status-section">
          <h4>👥 Agents ({agents.length})</h4>
          <div className="status-items">
            {agents.slice(0, 8).map((agent, idx) => (
              <div key={idx} className="status-item">
                <span className="item-status">✓</span>
                <span className="item-name">{agent.name}</span>
              </div>
            ))}
            {agents.length > 8 && (
              <div className="status-item">
                <span className="item-count">+{agents.length - 8} more</span>
              </div>
            )}
          </div>
        </div>

        {/* Skills */}
        <div className="status-section">
          <h4>⚡ Skills ({skills.length})</h4>
          <div className="status-items">
            {skills.map((skill, idx) => (
              <div key={idx} className="status-item">
                <span className="item-status">✓</span>
                <span className="item-name">{skill}</span>
              </div>
            ))}
          </div>
        </div>

        {/* MCP Servers */}
        <div className="status-section">
          <h4>🔌 MCP Servers ({mcpServers.length})</h4>
          <div className="status-items">
            {mcpServers.map((server, idx) => (
              <div key={idx} className="status-item">
                <span className="item-status">✓</span>
                <span className="item-name">{server.name} ({server.tools} tools)</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SystemStatus;
